"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeVueI18nNavigation = exports.getVueLegacyNavigationFlat = exports.getNavigationTranslationNav = exports.getNavTree = exports.navZhHans = exports.navEnUS = void 0;
const nav_en_US_1 = require("./nav-en-US");
Object.defineProperty(exports, "navEnUS", { enumerable: true, get: function () { return nav_en_US_1.navEnUS; } });
const nav_zh_Hans_1 = require("./nav-zh-Hans");
Object.defineProperty(exports, "navZhHans", { enumerable: true, get: function () { return nav_zh_Hans_1.navZhHans; } });
const byLang = {
    'zh-Hans': nav_zh_Hans_1.navZhHans,
    'en-US': nav_en_US_1.navEnUS,
};
function getNavTree(lang) {
    if (lang === 'zh-Hans' || lang === 'zh-CN' || lang === 'zh_CN')
        return nav_zh_Hans_1.navZhHans;
    return byLang['en-US'];
}
exports.getNavTree = getNavTree;
/**
 * React i18next：合并到 `translation.nav`，使用 `t('nav.mlops.overview')`。
 */
function getNavigationTranslationNav(lang) {
    return getNavTree(lang);
}
exports.getNavigationTranslationNav = getNavigationTranslationNav;
/**
 * Vue 2 vue-i18n：与历史 key 对齐（mlops.router.* / maas.router.*），便于容器现有文案键继续工作。
 */
function getVueLegacyNavigationFlat(lang) {
    const nav = getNavTree(lang);
    return {
        'mlops.router.overview': nav.mlops.overview,
        'mlops.router.aiMarket': nav.mlops.aiMarket,
        'mlops.router.computeMarket': nav.mlops.computeMarket,
        'mlops.router.trainAndInference': nav.mlops.trainAndInference,
        'mlops.router.containerInstance': nav.mlops.containerInstance,
        'mlops.router.trainTask': nav.mlops.trainTask,
        'mlops.router.trainTemplate': nav.mlops.trainTemplate,
        'mlops.router.inferenceService': nav.mlops.inferenceService,
        'mlops.router.aiAssets': nav.mlops.aiAssets,
        'mlops.router.dataset': nav.mlops.dataset,
        'mlops.router.modelManage': nav.mlops.modelManage,
        'mlops.router.containerImage': nav.mlops.containerImage,
        'mlops.router.repository': nav.mlops.repository,
        'mlops.router.diskStorage': nav.mlops.diskStorage,
        'mlops.router.resourceManage': nav.mlops.resourceManage,
        'mlops.router.dedicatedResource': nav.mlops.dedicatedResource,
        'mlops.router.resourceQuota': nav.mlops.resourceQuota,
        'mlops.router.resourceMonitor': nav.mlops.resourceMonitor,
        'mlops.router.resourceAudit': nav.mlops.resourceAudit,
        'mlops.router.systemSetting': nav.mlops.systemSetting,
        'mlops.router.resourceDashboard': nav.mlops.resourceDashboard,
        'mlops.router.computeCluster': nav.mlops.computeCluster,
        'mlops.router.storageCluster': nav.mlops.storageCluster,
        'maas.router.modelSquare': nav.maas.modelSquare,
        'maas.router.experienceCenter': nav.maas.experienceCenter,
        'maas.router.serviceManage': nav.maas.serviceManage,
        'maas.router.usageStatistics': nav.maas.usageStatistics,
        'maas.router.servicePrice': nav.maas.servicePrice,
        'maas.router.apiKey': nav.maas.apiKey,
        'maas.router.systemSetting': nav.maas.systemSetting,
        'maas.router.modelServiceSetting': nav.maas.modelServiceSetting,
        'mlops.router.knowledgeBase': nav.aiApp.knowledgeBase,
        'mlops.router.appBuild': nav.aiApp.appBuild,
        'mlops.router.appMarket': nav.aiApp.appMarket,
        'mlops.menu': nav.catalog.ml,
        'maas.menu': nav.catalog.maasServiceNav,
        'llmops.menu': nav.catalog.aiAppBuild,
    };
}
exports.getVueLegacyNavigationFlat = getVueLegacyNavigationFlat;
/** CloudPods 等：在拿到 i18n 实例后调用一次，合并 nav 树 + 兼容扁平 key */
function mergeVueI18nNavigation(i18n) {
    const pairs = [
        ['zh-CN', 'zh-Hans'],
        ['zh_CN', 'zh-Hans'],
        ['en', 'en-US'],
        ['en-US', 'en-US'],
    ];
    for (const [vueLocale, navLang] of pairs) {
        const nav = getNavTree(navLang);
        i18n.mergeLocaleMessage(vueLocale, { nav: { ...nav } });
        i18n.mergeLocaleMessage(vueLocale, getVueLegacyNavigationFlat(navLang));
    }
}
exports.mergeVueI18nNavigation = mergeVueI18nNavigation;
